import { useState } from 'react'

import { creditCardsSelector } from 'credit-cards/selectors'
import CreditCard from '@components/CreditCard'
import AddCreditCardModal from 'shared/components/AddCreditCardModal'
import Button from '@components/Button'
import Icon from '@components/Icon'
import { getCreditCardNumberPreview, getCreditCardType } from 'shared/utils'
import styles from './styles.module.scss'

const PaymentMethodsList = ({ creditCards = [], selectedCardId, onSelectCard }) => {
    const [showAddCardModal, setShowAddCardModal] = useState(false)

    return (
        <>
            <ul className={styles.paymentMethodsList}>
                {creditCards.map(({ id, cardType, nickName, cardLast4, expDate }) => (
                    <li className="d-flex align-items-center" key={id} onClick={() => onSelectCard(id)}>
                        <input className="mr-3" type="radio" name="brand" checked={selectedCardId === id} />
                        <Icon type={getCreditCardType(cardType)} className="mr-3" size="sm" withShadow />
                        <span className={styles.title} mr-2>
                            {getCreditCardNumberPreview({ nickName, cardLast4, expDate })}{' '}
                        </span>
                    </li>
                ))}
            </ul>
            <Button btnStyle="outline" onClick={() => setShowAddCardModal(true)}>
                <T>dashboard.label.add.credit.card</T>
            </Button>
            {showAddCardModal && <AddCreditCardModal onClose={() => setShowAddCardModal(false)} />}
        </>
    )
}

const mapStateToProps = createStructuredSelector({
    creditCards: creditCardsSelector,
})

export default connect(mapStateToProps)(PaymentMethodsList)
